/* eslint-disable react/prop-types */
import {
	IconButton,
	SwipeableDrawer,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';

export default function Drawer(props) {
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	// Check for dark theme
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	const {
		open,
		setOpen,
		medWidth,
		closeBtnTop,
		children,
		anchor = 'bottom',
		height = 'auto',
		customDetails,
		showCloseBtn = true,
		paperBackground,
	} = props;

	// eslint-disable-next-line no-unused-vars
	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event &&
			event.type === 'keydown' &&
			(event.key === 'Tab' || event.key === 'Shift')
		) {
			return;
		}
		setOpen(false);
	};

	return (
		<SwipeableDrawer
			anchor={anchor}
			open={open}
			PaperProps={{
				sx: {
					borderRadius: mobileScreen ? '1rem 1rem 0 0' : '0',
					width: '100%',
					minHeight: height,
					pb: '1rem',
				},
			}}
			onOpen={toggleDrawer('right', true)}
			onClose={toggleDrawer('right', false)}
			disableSwipeToOpen
		>
			{showCloseBtn && (
				<IconButton
					aria-label="close"
					onClick={toggleDrawer('right', false)}
					sx={{
						position: 'absolute',
						right: { xs: '1rem', md: '2rem' },
						top: '1rem',
						width: '2.5rem',
						height: '2.5rem',
						color: isDark ? '#FFFFFF' : theme.palette.primary.main,
						background: isDark ? '#2D2D2D' : theme.palette.primary.light,
					}}
					disableRipple
				>
					<Close />
				</IconButton>
			)}
			{children}
		</SwipeableDrawer>
	);
}
